<template>
  <div v-if="!loading">
    <v-slide-y-transition>
    <v-app-bar v-if="queueAppbar && this.arrAlertas.length > 0" class="fila-appbar"
      :style="{'padding-left': !$_isMobile ? 22 + '%' : 0}" >
      <core-fila-queue 
        :array="this.arrAlertas"
        :refs="$refs.monitoramento"
        ref="filaAppbar"
      />
    </v-app-bar>
    </v-slide-y-transition>
      <v-btn class="tv" v-if="!$_isMobile" color="green" @click="$_tv">
        <v-icon class="white--text">mdi-television</v-icon>
      </v-btn>
    <!-- CONDIÇÃO PRA VER SE O SCROLL PASSOU A FILA ACIMA -->
      <v-slide-y-transition>
      <core-fila-queue 
        :style="{'margin-top': 2 + '%'}"
        v-if="!queueAppbar && checkScrollbar"
        :array="this.arrAlertas"
        :refs="$refs.monitoramento"
        ref="fila"
      />
      </v-slide-y-transition>
      <div :class="{'container-card': $_alertas, 'd-flex': true, 'flex-wrap': true, 'justify-center': true}">
        <div
        v-for="( item, index) in secadores" :key="index" ref="monitoramento" >
          <app-card-monitoramento 
            :item="item"
            :parametroamostra="empparametroamostra"
            :primeiraamostra="empprimeiraamostra"
            :key="index"
            @lupa="$_cadastroSecador(item)"
            @abastecimento="$_cadastroAbastecimento(item)"
            @operacao="$_cadastroOperacao(item)"
            @armazenamento="$_cadastroArmazenamento(item)"
            @alerta="$_secadorAlerta"
          />
        </div>
      </div>
    <v-dialog v-model="cadastro" max-width="500px" width="80%" persistent>
      <app-dialog-secador 
      :idsecador="idsecador"
      :identificar="cadastro"
      @update="$_update"
      />
    </v-dialog>
    
    <v-dialog v-model="armazenar" max-width="500px" width="80%" persistent>
      <app-dialog-secador 
      :numeroamostras="numeroamostras"
      :idsecador="idsecador"
      :loa="armazenar"
      @update="$_update"
      @voltar="armazenar = false"
      />
    </v-dialog>

    <v-dialog v-model="abastecer"  max-width="500px" width="80%" persistent ref="dialogABA">
      <app-dialog-secador
      :qr="qr"
      :idsecador="idsecador"
      :abastecer="abastecer"
      :abaoperacao="abaoperacao"
      :abacard="abacard"
      @update="$_update"
      @voltar="abastecer = false"
      @qr="abastecer = true"
      />
    </v-dialog>

    <v-dialog v-model="abastecerLotes" max-width="500px" width="80%" persistent>
      <v-card>
        <v-card-title
          class="header headline green white--text justify-space-between">
          <div class="header">
            <v-icon @click="abastecerLotes = false" class="icone white--text">mdi-arrow-left</v-icon>
            Abastecer</div>
          <v-icon large class="mx-1 my-1 icone white--text"> mdi-grain </v-icon>
        </v-card-title>
        <div class="d-flex justify-center">
          <v-btn color="primary" class="my-3" @click="$_abastecer">Adicionar Lote</v-btn>
        </div>
        <div class="container">
          <div class="card-lote-wrapper" >
            <div v-for="item in lotes" :key="item?.id" ref="card-lote" class="card-lote">
              <app-card-secador-lote 
                :value="item" class="card"
                @onClickRemover="$_removerAbastecimento"
                @onClickEditar="$_editarAbastecimento"
              >
              </app-card-secador-lote>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="operacao" max-width="500px" width="80%" persistent>
      <app-dialog-secador 
      :idsecador="idsecador"
      :op="operacao"
      @update="$_update"
      @voltar="operacao = false"
      />
    </v-dialog>

    <v-dialog v-model="amostras" max-width="500px" width="100%" persistent>
      <v-card>
        <v-card-title
          class="header headline green white--text justify-space-between">
          <div class="header">
            <v-icon @click="amostras = false" class="icone white--text">mdi-arrow-left</v-icon>
            Operação - Amostras</div>
          <v-icon large class="mx-1 my-1 icone white--text"> mdi-button-pointer </v-icon>
        </v-card-title>
        <div class="header">
          <!-- talvez seja melhor fazer um card mostrando as informação da operação -->
          <v-card-title class="justify-space-between">
            <div v-for="lote in operacaoamostra.nrolotes" :key="lote">
              <span>{{lote}}</span>
            </div>
          </v-card-title>
          <div class="d-inline-flex mx-3">
              <v-text-field
              label="Data Ínicio"
              readonly
              outlined
              background-color="white"
              :value="$_formataData(operacaoamostra.datainicio,'DD/MM/YYYY HH:mm')"
              >
              </v-text-field>
          </div>
        </div>
        <v-divider></v-divider>
        <div class="d-flex justify-center">
          <v-btn color="primary" class="my-3" @click="$_cadastroAmostra">Adicionar Amostra</v-btn>
        </div>
        <v-divider></v-divider>
        <div class="card-amostra overflow-x-hidden overflow-y-auto">
          <div class="mx-5" v-for="(cardAmostra,index) in dbamostras" :key="index">
            <app-card-amostra 
              v-if="(index === dbamostras.length - 1)"
              :position="true"
              :value="cardAmostra"
              @onClickEditar="$_editarAmostra"
              @onClickRemover="$_removerAmostra"
            />
            <app-card-amostra 
              v-else
              :value="cardAmostra"
              @onClickEditar="$_editarAmostra"
              @onClickRemover="$_removerAmostra"
            />
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cadastroAmostra"  max-width="500px" width="80%" persistent>
        <app-dialog-amostra 
          :operacao="operacaoamostra"
          :dialogState="cadastroAmostra"
          :editarAmostra="editarAmostra"
          @update="$_update"
          @voltar="cadastroAmostra = false, amostras = true"
        />
    </v-dialog>

    <v-dialog v-model="remocaoAmostra"  max-width="400px" width="80%" persistent>
      <v-card>
      <v-card-title class="header headline red white--text justify-space-between">
        <div class="header">
          <v-icon @click="remocaoAmostra = false, amostras = true" class="icone white--text">mdi-arrow-left</v-icon>
          Remover Amostra</div>
        <v-icon large class="mx-1 my-1 icone white--text"> mdi-delete-outline </v-icon>
      </v-card-title>
      <div class="mx-4 my-auto">
        <v-card-text  class="font-weight-medium text-subtitle-1">
          Para excluir essa amostra, deve acessar o ERP.
        </v-card-text>
        <!-- <app-card-amostra 
          :value="this.cardAmostra"
          :semBotoes="true"
          readonly
        /> -->
        <div class="d-flex justify-center">
          <v-btn class="my-3" @click="remocaoAmostra = false;">Voltar</v-btn>
          <!-- <v-btn color="red" class="my-3 white--text" @click="$_removerAmostra({excluir: true, cardAmostra})">Excluir</v-btn> -->
        </div>
      </div>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="remocaoAbastecimento"  max-width="400px" width="80%" persistent>
      <v-card>
      <v-card-title class="header headline red white--text justify-space-between">
        <div class="header">
          <v-icon @click="remocaoAbastecimento = false, abastecerLotes = true" class="icone white--text">mdi-arrow-left</v-icon>
          Remover</div>
        <v-icon large class="mx-1 my-1 icone white--text"> mdi-delete-outline </v-icon>
      </v-card-title>
      <div class="mx-4 my-auto">
        <v-card-text class="font-weight-medium text-subtitle-1">Deseja excluir o seguinte abastecimento?</v-card-text>
        <app-card-secador-lote 
          :value="this.abacard" class="card"
          :semBotoes="true"
        >
        </app-card-secador-lote>
        <div class="d-flex justify-space-between">
          <v-btn class="my-3" @click="remocaoAbastecimento = false;">Voltar</v-btn>
          <v-btn color="red" class="my-3 white--text" @click="$_removerAbastecimento({excluir: true, abacard})">Excluir</v-btn>
        </div>
      </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from '@/plugins/dexie'
import moment from 'moment-timezone';
import AppCardMonitoramento from '@/components/app/card/monitoramento/Index.vue'
import AppDialogSecador from '@/components/app/dialog/secador/Index.vue'
import AppCardSecadorLote from '@/components/app/card/secadorlote/Index.vue'
import AppCardAmostra from '@/components/app/card/amostra/Index.vue'
import AppDialogAmostra from '@/components/app/dialog/amostra/Index.vue'
import { SECADOR_STORAGE } from '@/constants/STORAGE';
import geraData from '@/utils/geradata';
import { mapActions } from 'vuex';
import ToggleNavigationDrawerEvent from '@/events/ToggleNavigationDrawerEvent';
import ToggleAppBarEvent from '@/events/ToggleAppBarEvent';
import errorHandler from '@/utils/error-handler';
import { SetupEnvioLocal } from '@/utils/atualizalocal';
import CoreFilaQueue from '@/components/core/fila-queue/Index.vue'

export default {
  name: 'ViewMonitoramento',

  components: {
    AppCardMonitoramento,
    AppDialogSecador,
    AppCardSecadorLote,
    AppDialogAmostra,
    AppCardAmostra,
    CoreFilaQueue
  },

  data() {
    return {
      loading: true,
      
      empprimeiraamostra: null,
      empparametroamostra: null,
      empumidadecorte: null,
      secadores: [],
      idsecador: null,
      idteste: null,
      
      lotes: [],
      abastecerLotes: null,
      cadastro: null,
      abastecer: null,
      abaoperacao: null,
      abacard: {},
      remocaoAbastecimento: null,
      itemAbastecimento: null,
      
      operacao: null,
      
      operacaosecador: null,

      amostras: null,
      operacaoamostra: {},
      cadastroAmostra : null,
      dbamostras: [],
      editarAmostra: null,
      remocaoAmostra: null,
      cardAmostra: {},
      qntdAmostras: null,
      
      armazenar: null,
      infosecagem: null,
      numeroamostras: null,

      mode:false,
      alerta: false,
      arrAlertas: [],
      scrollPosition: null,
      queueAppbar: false,
      qr: null,
      checkScrollbar: null,
    }
  },
  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    $_alertas() {
      return this.arrAlertas.length > 0 ? true : false
    },
    $_scrollPosition() {
      return this.scrollPosition
    },
  },
  methods: {
    ...mapActions({
      $_empresa: 'empresa/find',
    }),

    $_scroll(){
      window.addEventListener("scroll", (() => this.scrollPosition = window.scrollY));
    },

    $_secadorAlerta(id){
      if(!this.arrAlertas.includes(id) && !id.excluir) this.arrAlertas.push(id);
      else if (id?.excluir) this.arrAlertas = this.arrAlertas.filter((item) => item !== id.excluir)
      console.log('FOI EMITIDO UM ALERTA',id, this.arrAlertas)
    },

    async $_load(filter) {
      const secadores = await db.secador.orderBy('scdidsecador').toArray();
      for (const scd of secadores) {
        let lotesnro = []
        const abastecimento = (await db.abastecimentosecagem.where({absidsecador: scd.scdidsecador })
          .filter((x) => !x.abssecagem && !x.absdeletar).toArray());
        let alerta = this.alerta;
        let ultimaDataInicio;
        let ultimaDataTermino;
        let statusSecador;
        let ultimaUmidade;
        let dataPrevisao;
        let previsaoEmData;
        let dataRestante;
        let supostaUmidade;
        
        let operacao = await db.operacao.where({opeidsecador: scd.scdidsecador}).filter((op) => !op.opesecagem).first();
  
        for (const aba of abastecimento) {
            statusSecador = await this.$_estadoAbastecimento(scd.scdidsecador);

            ultimaDataInicio = ultimaDataInicio > aba.absdatainicio ? ultimaDataInicio : aba.absdatainicio;
            ultimaDataTermino = ultimaDataTermino > aba.absdatatermino ? ultimaDataTermino : aba.absdatatermino;
            
            const lote = await db.aberturalote.where({ablidaberturalote: aba.absidaberturalote}).first();
            lotesnro.push(lote.ablnrocontrole)
        }
        //await db.amostra.where({operacaosecador.id})
        if(operacao) {
          //const umidades = await db.amostra.where({amoidoperacao: operacao.id}).reverse().first();
          const umidades = await db.amostra.where({
            amodataoperacao: operacao.opedatainicio, 
            }).reverse().toArray();

          const {amodataamostra} = umidades[0] || null;
          statusSecador = umidades[0].amostatus === 'DESLIGADO' ? umidades[0].amostatus : 'OPERANDO';
          for (const index in umidades) {
            const { amoumidade, amoumidadebaixo, amoumidademeio, amoumidadecima} = umidades[index];
            if ( !ultimaUmidade && (amoumidade || amoumidadebaixo || amoumidademeio || amoumidadecima)) {
              const valores = [amoumidadebaixo, amoumidadecima, amoumidademeio].filter((item) => item !== undefined);
    
              if (valores.length > 0 && !amoumidade) {
                ultimaUmidade = Math.max(...valores);
              }else {
                ultimaUmidade = amoumidade;
              } 
            }            
          }


          dataPrevisao = this.$_previsao(ultimaUmidade, scd.scdperdaumidadehora);
          previsaoEmData = this.$_previsao(ultimaUmidade, scd.scdperdaumidadehora, operacao.opedatainicio)
          console.log('previsao em data', previsaoEmData)
          // FAZENDO ALGO PARA CALCULAR A DATA RESTANTE DE ACORDO COM O TEMPO ATIVO,
          // CONSEGUIMOS SABER O TEMPO DE ATIVIDADE PELAS AMOSTRAS,
          const tempoAtivo = await this.$_atividadeSecador(operacao.opedatainicio,scd.scdperdaumidadehora,`${scd.scdidsecador}º secador`)
          //console.log('tempoativoLoad', `${scd.scdidsecador}º secador`,dataPrevisao, tempoAtivo, operacao, this.$_conversaoHoraMinuto(tempoAtivo));
          const ativoMinutos = this.$_conversaoHoraMinuto(tempoAtivo);
          //console.log('previsoes', previsaoEmData, dataPrevisao, tempoAtivo, ativoMinutos)
          if(ativoMinutos < 0 || (tempoAtivo && ativoMinutos > this.$_conversaoHoraMinuto(dataPrevisao))) {
            //dataRestante = this.$_restante(dataPrevisao, dataPrevisao);
            dataRestante = this.$_restante(dataPrevisao, dataPrevisao );
            /// ACHO QUE É AQUI QUE TÁ COLOCANDO AMODATASTATUS EM TUDO, NAO PODE
              console.log('É AQUI????', tempoAtivo, typeof tempoAtivo, dataPrevisao, ultimaUmidade)
            if(!(umidades[0].amodatastatus)){
              await db.amostra.update(umidades[0].id, {
                amodatastatus: geraData(),
                amodatanuvem: null,
              })
            }
            statusSecador = 'FINALIZADO'
          }else if (operacao.opedatainicio > geraData()){
            statusSecador = 'AGENDADO'
          }else {
            dataRestante = this.$_restante(dataPrevisao, tempoAtivo);
            console.log(scd.id, dataRestante, dataPrevisao, tempoAtivo);
          }
          
          if(this.$_comparacaoDatas(geraData(), previsaoEmData) > 0 && statusSecador === 'OPERANDO') {
              previsaoEmData = moment(geraData()).add(dataRestante, 'minutes').format('YYYY-MM-DD HH:mm');
          }
          if (statusSecador !== 'FINALIZADO' && umidades[0].amodatastatus) {
            await db.amostra.update(umidades[0].id, {
              amodatastatus: null,
            })
          }

          if(statusSecador === 'DESLIGADO') {
            supostaUmidade = this.$_supostaUmidade('DESLIGADO', dataPrevisao, ultimaUmidade, scd.scdperdaumidadehora, tempoAtivo);
          } else if (statusSecador === 'OPERANDO'){
            supostaUmidade = this.$_supostaUmidade('OPERANDO', amodataamostra, ultimaUmidade, scd.scdperdaumidadehora, tempoAtivo);
          } else if(statusSecador === 'FINALIZADO') {
            supostaUmidade = this.empumidadecorte;
          }
        }
        if(!filter) {
          if (abastecimento.length > 0) {
  
            this.secadores.push({
              scdidsecador: scd.scdidsecador,
              absdatainicio: ultimaDataInicio,
              absdatatermino: ultimaDataTermino,
              absidsecador: scd.scdidsecador,
              scdidaberturalote: lotesnro,
              operacao: operacao,
              umidade: ultimaUmidade,
              supostaumidade: supostaUmidade,
              status: statusSecador,
              datainicio: operacao ? operacao.opedatainicio : null,
              dataprevisao: operacao ? previsaoEmData : null,
              previsaomonit: operacao ? this.$_previsao(ultimaUmidade, scd.scdperdaumidadehora) : null,
              datarestante: dataRestante,
              perdaumidadehora: scd.scdperdaumidadehora,
              perdaumidadeperc: scd.scdperdaumidadepercentual,
            }
            )
          } else {
            this.secadores.push({
              scdidsecador: scd.scdidsecador,
              perdaumidadehora: scd.scdperdaumidadehora,
              perdaumidadeperc: scd.scdperdaumidadepercentual,
              scdidaberturalote: null,
              umidade: null,
              status: null,
              operacao: null
              }
            )
          }
        } else {
          const index = this.secadores.findIndex((sec) => sec.scdidsecador === scd.scdidsecador)
          this.secadores.splice(index, 1,{
              scdidsecador: scd.scdidsecador,
              absdatainicio: ultimaDataInicio,
              absdatatermino: ultimaDataTermino,
              absidsecador: scd.scdidsecador,
              scdidaberturalote: lotesnro.length > 0 ? lotesnro : null,
              operacao: operacao,
              umidade: ultimaUmidade,
              supostaumidade: isNaN(supostaUmidade) ? null : supostaUmidade,
              status: statusSecador,
              datainicio: operacao ? operacao.opedatainicio : null,
              dataprevisao: operacao ? previsaoEmData : null,
              previsaomonit: operacao ? this.$_previsao(ultimaUmidade, scd.scdperdaumidadehora) : null,
              datarestante: dataRestante ? dataRestante : null,
              perdaumidadehora: scd.scdperdaumidadehora,
              perdaumidadeperc: scd.scdperdaumidadepercentual,
              alerta: !alerta
            })
            this.alerta = true;
        }
      }
      console.log('secadores',this.secadores)
      this.loading = false;
    },


    async $_update(item) {
      this.idsecador = null;
      const usuario = await db.usuario.where({useidnuvem: sessionStorage.getItem('user:useidnuvem')}).first();
      console.log('envio', item)
      const index = this.secadores.findIndex((sec) => sec.scdidsecador === item.secid)

      if (item.tipo === 'abastecimento') {
          const checkdb = await db.abastecimentosecagem.where({absidsecador: item.secid,absidaberturalote: item.idaberturalote }).first()
          if (checkdb) {
            console.log('itemdentrodocheckdb',item)
            db.abastecimentosecagem.update(checkdb.id, {
              absdatatermino: item.termino,
                absstatus: item.termino ? 'ABASTECIDO' : 'ABASTECENDO',
                absdatanuvem: null,
              });

            const loteindex = this.lotes.findIndex((lot) => lot.inicio = item.inicio);
            console.log('lotind', this.lotes[loteindex], loteindex)
            this.lotes.splice(index ,1, {
              ...this.lotes[index],
              termino: item.termino,
              umidade: item.umidade
              });
          } else {
            if(['FINALIZADO', 'OPERANDO'].includes(this.secadores[index].status)) {
              errorHandler('Não é possível adicionar um abastecimento na operação já iniciada.')
            } else {
              db.abastecimentosecagem.add({
                absdatatermino: item?.termino,
                absidsecador: item.secid,
                absidaberturalote: item.idaberturalote,
                absdatainicio: item.inicio,
                absstatus: item.termino ? 'ABASTECIDO' : 'ABASTECENDO',
                absdatanuvem: null,
              })
              if (this.secadores[index].scdidaberturalote) {
                this.secadores[index].scdidaberturalote = [
                  `${this.secadores[index].scdidaberturalote}`,
                  (await db.aberturalote.where({ablidaberturalote: item.idaberturalote}).first()).ablnrocontrole
                ];
              } else {
                this.secadores[index].scdidaberturalote = [(await db.aberturalote.where({ablidaberturalote: item.idaberturalote}).first()).ablnrocontrole] 
              }
            }
          }
          this.secadores[index].status = await this.$_estadoAbastecimento(item.secid);

          this.secadores[index].absdatainicio = item?.inicio;
          this.secadores[index].absdatatermino = this.secadores[index].status === 'ABASTECIDO' ? item.termino : null
          this.abastecer = false;
          this.$_cadastroAbastecimento(this.secadores[index]);

      } else if (item.tipo === 'operacao') {
        // FAZER ADIÇÃO TBM NA TABELA DE SECAGEM
        console.log('CAIU')
        const operacaoid = await db.operacao.add({
          opetipo: item.operacao,
          opeidsecador: item.secid,
          opepeso: item.peso,
          opeumidade: item.umidade,
          opeumidadear: item.umidadear,
          opetemperaturaar: item.temperaturaar,
          opedatainicio: item.inicio,
          opeidusuario: sessionStorage.getItem('user:useidusuario'),
        })
        await db.amostra.add({
            amoumidade: item.umidade,
            amostatus: 'LIGADO',
            amoidoperacao: operacaoid,
            amodataamostra: item.inicio,
            amodataalteracao: item.inicio,
            amoidusuario: sessionStorage.getItem('user:useidusuario'),
            amooperador: usuario ? usuario.usenome : '---',
            amodataoperacao: item.inicio,
          })

          this.$_updateSecagem('add', item)

          this.secadores[index].operacao = await db.operacao.where({
            opedatainicio: item.inicio, opeidsecador: item.secid
            }).first();
          this.secadores[index].status = 'OPERANDO'
          this.secadores[index].umidade = item.umidade
          this.secadores[index].supostaumidade = item.umidade
          this.secadores[index].datainicio = item.inicio
          this.secadores[index].dataprevisao = this.$_previsao(
            item.umidade,
            this.secadores[index].perdaumidadehora,
            item.inicio
          );

          this.secadores[index].datarestante = this.$_restante(this.$_previsao(item.umidade,this.secadores[index].perdaumidadehora));
          this.operacao = false;

      } else if (item.tipo === 'amostra') {
        const checkdb = await db.amostra.where({amodataamostra: item.dataamostra}).first();
        console.log('CHECKDBUPDATEAMOSTRA', checkdb, item.dataamostra, item)
        const amostraRecente = await db.amostra.where({
          amodataoperacao: item.operacao.datainicio
          }).reverse().first();
        console.log('AAAAAAAAAAAAAAAAAAAAA', amostraRecente)
        if (checkdb) {
          console.log('update')
          db.amostra.update(checkdb.id, {
            amoobservacao: item?.observacao,
            amoumidade: item?.umidade,
            amoumidadebaixo: item?.umidadebaixo,
            amoumidademeio: item?.umidademeio,
            amoumidadecima: item?.umidadecima,
            amofluxoar: item?.fluxoar,
            amostatus: item?.status,
            amoidusuario: sessionStorage.getItem('user:useidusuario'),
            amodatanuvem: null,
            amodatastatus: null,
          })
        } else {
          console.log('add')
          db.amostra.update(amostraRecente?.id, {
            amodatastatus: item.dataamostra,
            amodatanuvem: null,
          })
          db.amostra.add({
            amoobservacao: item.observacao,
            amoumidade: item.umidade,
            amoumidadebaixo: item.umidadebaixo,
            amoumidademeio: item.umidademeio,
            amoumidadecima: item.umidadecima,
            amofluxoar: item.fluxoar,
            amostatus: item.status,
            amoidoperacao: item.operacao.idoperacao,
            amodataamostra: item.dataamostra,
            amoidusuario: sessionStorage.getItem('user:useidusuario'),
            amooperador: usuario.usenome,
            amodataoperacao: item.operacao.datainicio,
            amodatanuvem: null,
          })
        } 
        const umidades = item?.umidade || item?.umidadebaixo || item?.umidademeio || item?.umidadecima;
        const tempoAtivo = await this.$_atividadeSecador(
            item.operacao.datainicio, item.operacao.idusuario, this.secadores[index].perdaumidadehora
          );
        const previsao = this.$_previsao(this.secadores[index].umidade, this.secadores[index].perdaumidadehora)
        console.log('umidades', umidades)

        if (umidades) {
          this.secadores[index].umidade = umidades;
          this.secadores[index].supostaumidade = umidades;
          this.secadores[index].dataprevisao = this.$_previsao(
            umidades,
            this.secadores[index].perdaumidadehora,
            this.secadores[index].datainicio
          );
          this.secadores[index].previsaomonit = this.$_previsao(umidades,this.secadores[index].perdaumidadehora);
          this.secadores[index].datarestante = this.$_restante(this.$_previsao(umidades,this.secadores[index].perdaumidadehora));
          this.secadores[index].status = 'OPERANDO';
        }else {
          
          
          //const previsaoTeste = this.$_previsao(this.secadores[index].umidade, this.secadores[index].perdaumidadehora, this.secadores[index].datainicio)

          if(this.secadores[index].status === 'DESLIGADO') {
            const restanteMinutos = this.$_conversaoHoraMinuto(this.secadores[index].datarestante);
            const novaPrevisao = moment(geraData()).add(restanteMinutos, 'minutes').format('YYYY-MM-DD HH:mm')
            this.secadores[index].dataprevisao = novaPrevisao;

            const novaPrevMinutos = this.$_conversaoHoraMinuto(geraData(novaPrevisao, 'HH:mm'))
            const calcPrevMonit = novaPrevMinutos + this.$_comparacaoDatas(geraData(),novaPrevisao)
            this.secadores[index].previsaomonit = this.$_conversaoMinutoHora(calcPrevMonit);
            console.log('MONIT', novaPrevMinutos, calcPrevMonit, this.$_conversaoMinutoHora(calcPrevMonit))
            
            this.secadores[index].status = 'OPERANDO';
            this.secadores[index].supostaumidade = this.$_supostaUmidade('OPERANDO', item.dataamostra, 
              this.secadores[index].umidade, this.secadores[index].perdaumidadehora,
              tempoAtivo);
            //console.log('previsaosemumidade', previsaoTeste, previsao, tempoAtivo, previsaoTeste < geraData(), restanteMinutos, novaPrevisao);

            console.log('a resposta está aqui', tempoAtivo, previsao, tempoAtivo < previsao)
          } else if(tempoAtivo < previsao){
            this.secadores[index].supostaumidade = this.$_supostaUmidade('OPERANDO', item.dataamostra, 
              this.secadores[index].umidade, this.secadores[index].perdaumidadehora,
              tempoAtivo);
            this.secadores[index].status = 'OPERANDO'
            this.secadores[index].datarestante = this.$_restante(previsao, tempoAtivo)
          } else {
            this.secadores[index].supostaumidade = this.empumidadecorte;
            this.secadores[index].status = 'FINALIZADO';
            }
        } 

        if(item.status === 'DESLIGADO') {
          this.secadores[index].status = tempoAtivo > previsao ? 'FINALIZADO' : 'DESLIGADO';
          this.secadores[index].supostaumidade = null;
        }

        this.dbamostras = await db.amostra.where({
          amodataoperacao: item.operacao.datainicio, 
          }).toArray();
        this.cadastroAmostra = false;
        this.amostras = true;

      } else if (item.tipo === 'armazenamento') {
        
  
        for (const ids of this.infosecagem.scdidaberturalote) {
          const abs = await db.abastecimentosecagem.where({
            absidaberturalote: ids}).first();
          await db.abastecimentosecagem.update(abs.id, {
            abssecagem: 'S',
            absdatanuvem: null,
          })
          const abl = await db.aberturalote.where({
            ablidaberturalote: ids}).first();
          await db.aberturalote.update(abl.id, {
            ablsecagem: 'S',
          })
        }
        await db.operacao.update(this.infosecagem.operacao.opedatainicio, {
          opesecagem: 'S'
        })

        await this.$_updateSecagem('update', {
          ...this.infosecagem, 
          datatermino: item.data, 
          loaidlocalarmazenamento: item.local.loaidlocalarmazenamento,
        });

        this.armazenar = false;
      }

      SetupEnvioLocal();
      this.$_load('filter');
    },

    async $_updateSecagem(metodo, item) {
      console.log('METODOUPDATESECAGEM', metodo, item)
      if(metodo === 'add') {
        await db.secagem.add({
          secdatainicio: item.inicio,
          secidusuario: sessionStorage.getItem('user:useidusuario'),
          sectipooperacao: item.operacao,
          secumidadear: item.umidadear,
          sectemperaturaar: item.temperaturaar,
          secumidade: item.umidade,
          secpesoentrada: item.peso,
          secidsecador: item.secid,
          secdatanuvem: null,
        })
      } else if (metodo === 'update') {
        const checkNuvem = await db.secagem.where({
          secdatainicio: item.datainicio
        }).first();
        const tempoAtivo = await this.$_atividadeSecador(item.operacao.opedatainicio,item.operacao.opeidusuario,item.perdaumidadehora)
        console.log('tepmoativo', tempoAtivo)
        const restante = this.$_conversaoHoraMinuto(item?.datarestante)
        const previsao = this.$_conversaoHoraMinuto(item?.previsaomonit)
        const horaAtivo = this.$_conversaoMinutoHora((previsao - restante),'0');
        console.log('ITEMATT', this.infosecagem, checkNuvem, restante, previsao)
        await db.secagem.update(checkNuvem.id, {
            secstatus: 'S',
            secdatatermino: item.datatermino,
            sectempooperacao: horaAtivo,
            secidlocalmovimentacaoestoque: item.loaidlocalarmazenamento,
            secdatanuvem: null,
          })
      SetupEnvioLocal();
      this.$_load('filter');
      }
    },

    $_cadastroSecador(secador) {
      this.idsecador = secador.scdidsecador;
      console.log('clicou', secador, this.idsecador)
      sessionStorage.setItem(SECADOR_STORAGE.secagem, JSON.stringify(secador))
      this.cadastro = true;
    },

    async $_cadastroAbastecimento(abastecimento) {
      this.lotes = []
      this.itemAbastecimento = abastecimento;
      this.idsecador = null;
      this.idteste = abastecimento.scdidsecador;
      if (abastecimento.scdidaberturalote) {
        const nrosLotes = Array.isArray(abastecimento.scdidaberturalote) ? abastecimento.scdidaberturalote : [abastecimento.scdidaberturalote];
        for (const index in nrosLotes) {
          const loteInfo = (await db.aberturalote.where({ablnrocontrole: nrosLotes[index]}).first());
          const absInfo = await db.abastecimentosecagem.where({
            absidaberturalote: loteInfo.ablidaberturalote,
            absidsecador: abastecimento.scdidsecador}).first();
          this.lotes.push({
            id: absInfo.id,
            inicio: absInfo.absdatainicio,
            termino: absInfo?.absdatatermino,
            nrolote: loteInfo.ablnrocontrole,
            status: absInfo.absstatus,
            usuario: {id: absInfo.absidusuario, nome: absInfo.absoperador}
          })
        }
      }

      this.abastecerLotes = true;
    },

    async $_cadastroOperacao(item) {
      this.idsecador = item.scdidsecador;
      console.log('clicou', item, this.operacao)
      if(!item.operacao) this.operacao = true;
      else {
        this.dbamostras = await db.amostra.where({
          amodataoperacao: item.operacao.opedatainicio}).toArray();
        this.amostras = true;
        this.operacaoamostra = {
          idoperacao: item.operacao.id,
          idusuario: item.operacao.opeidusuario,
          idsecador : item.operacao.opeidsecador,
          datainicio: geraData(item.operacao.opedatainicio),
          nrolotes: Array.isArray(item.scdidaberturalote) ? item.scdidaberturalote : [item.scdidaberturalote]
        }
        console.log(this.amostras)
      }
    },

    $_abastecer() {
      this.idsecador = this.idteste;
      this.abacard = null;
      const index = this.secadores.findIndex((sec) => sec.scdidsecador === this.idsecador)
      this.abaoperacao = this.secadores[index].operacao;
      this.abastecerLotes = false;
      this.abastecer = true;
    },
    
    $_abastecerQR(){
      const qr = sessionStorage.getItem('qr')
      if(qr && qr.length && qr !== 'null'){
        const form = JSON.parse(sessionStorage.getItem('formulario'));
        console.log('POERPEORPEOREOPORPE',form, form.id, form.inicio, form.termino)
        this.idsecador = form.idsecador
        this.idteste = form.id
        this.qr = form
        this.abastecer = true;
      }
    },

    async $_cadastroAmostra() {
      this.editarAmostra = null;
      this.cadastroAmostra = true;
    },

    async $_cadastroArmazenamento(item) {
      this.idsecador = item.scdidsecador;
      let idlotes = [];
      const nrosLotes = Array.isArray(item.scdidaberturalote) ? item.scdidaberturalote : [item.scdidaberturalote];
        for (const nro of nrosLotes) {
          const loteInfo = (await db.aberturalote.where({ablnrocontrole: nro}).first())
          idlotes.push(loteInfo.ablidaberturalote);
        }
      this.infosecagem = {...item, scdidaberturalote: idlotes};
      this.numeroamostras = (await db.amostra.where({amodataoperacao: item.operacao.opedatainicio}).toArray()).length;
      console.log('clicounoarmazem',this.infosecagem)
      this.armazenar = true;
    },

    async $_clickCard(idCard) {
      this.idsecador = this.idteste;
        
        setImmediate(async () => {
          this.abacard =  await db.abastecimentosecagem.where({id: idCard}).first();
        })
        console.log('clique no card', idCard, this.abacard)
        this.abastecer = true;
        this.abastecerLotes = false;

    },

    $_formataData(date, mascara) {
      return moment.tz(date, 'America/Sao_Paulo').local().format(mascara);
    },

    async $_removerAmostra(amostra) {
      /* if (amostra.excluir) {

        const index = this.secadores.findIndex((sec) => {
          const datas = sec?.operacao?.opedatainicio === amostra.cardAmostra.amodataoperacao; 
          const users = sec?.operacao?.opeidusuario === amostra.cardAmostra.amoidusuario;
          if(datas && users) return sec;
        });

        await db.amostra.where({id: amostra.cardAmostra.id}).delete();
        if(this.qntdAmostras === 1) {
          await db.operacao.where({
            opedatainicio: amostra.cardAmostra.amodataoperacao}).delete();

          const limpar = ['operacao','datarestante','dataprevisao','datainicio','umidade','supostaumidade']
          for (const key of limpar) this.secadores[index][key] = null;

          this.secadores[index].status = await this.$_estadoAbastecimento(this.secadores[index].scdidsecador);
          this.amostras = false;
          this.dbamostras = null;
        } else {

        let umidade;
        const arrayAmostras = await db.amostra.where({
          amodataoperacao: amostra.cardAmostra.amodataoperacao
         }).reverse().toArray();
        const ultimaAmostra = await db.amostra.where({
          amodataoperacao: amostra.cardAmostra.amodataoperacao
        }).reverse().first();
        for (const amostra in arrayAmostras) {
          const {amoumidade, amoumidadebaixo, amoumidadecima} = arrayAmostras[amostra];
          const valores = [amoumidadebaixo, amoumidadecima].filter((item) => item !== undefined);

            if (!umidade) {
              if (valores.length > 0 && !amoumidade) {
                umidade = Math.max(...valores);
              }else {
                umidade = amoumidade;
              } 
            }
          }


        await db.amostra.update(ultimaAmostra.id, {
          amodatastatus: null
        });

        this.secadores[index].dataprevisao = this.$_previsao( umidade, this.secadores[index].perdaumidadehora, this.secadores[index].datainicio)
        const {perdaumidadehora} = this.secadores[index];
        const previsaoHora = this.$_previsao( umidade, this.secadores[index].perdaumidadehora)

        const tempoPercorrido = await this.$_atividadeSecador(
          ultimaAmostra.amodataoperacao, ultimaAmostra.amoidusuario, perdaumidadehora,
        )
        const ativoMinutos = this.$_conversaoHoraMinuto(tempoPercorrido);
        if(ativoMinutos < 0 ) {
          this.secadores[index].datarestante = this.$_restante(previsaoHora, previsaoHora);
          this.secadores[index].status = 'FINALIZADO';
          this.secadores[index].umidade = umidade; 
          this.secadores[index].supostaumidade = this.empumidadecorte;
        } else {
          this.secadores[index].datarestante = this.$_restante(previsaoHora, tempoPercorrido);
          this.secadores[index].status = ultimaAmostra.amostatus === 'LIGADO' ? 'OPERANDO' : 'DESLIGADO';
          this.secadores[index].umidade = umidade; 
          this.secadores[index].supostaumidade = this.$_supostaUmidade(this.secadores[index].status,ultimaAmostra.amodataamostra, umidade, perdaumidadehora, tempoPercorrido);
          
          } 
        }
        this.dbamostras = await db.amostra.where({
          amodataoperacao: amostra.cardAmostra.amodataoperacao,
        }).toArray();
        this.amostras = false;
        this.remocaoAmostra = false;
        } else { */
        this.cardAmostra = await db.amostra.where({id: amostra}).first();
        this.qntdAmostras = (await db.amostra.where({
          amodataoperacao: this.cardAmostra.amodataoperacao}).toArray()).length
        console.log('clicou pra remover', amostra, this.cardAmostra, this.qntdAmostras)
        this.remocaoAmostra = true;
      
    },

    async $_editarAmostra(amostra) {
      setImmediate(async () => {
        this.editarAmostra = await db.amostra.where({id: amostra}).first();
      })
      this.cadastroAmostra = true;
      console.log('clique editar', amostra, this.editarAmostra)
    },

    async $_estadoAbastecimento(idsecador) {
      let estadoSecador;
      let retorno;
      const abastecimentos = await db.abastecimentosecagem.where({absidsecador: idsecador}).filter((x) => !x.abssecagem).toArray();
      if (abastecimentos.length > 1) {
        for (const aba of abastecimentos) {
          if(estadoSecador && (aba.absstatus !== estadoSecador)) retorno = 'ABASTECENDO'
          else if (estadoSecador && (aba.absstatus === estadoSecador)) retorno = estadoSecador;
          estadoSecador = aba.absstatus
        }
      } else retorno = abastecimentos[0].absstatus;
      return retorno;
    },

    async $_editarAbastecimento(abastecimento) {
      this.idsecador = this.idteste;
        this.abacard =  await db.abastecimentosecagem.where({id: abastecimento}).first();
        console.log('clique no card', abastecimento, this.abacard);
        this.abastecer = true;
        this.abastecerLotes = false;

    },

    async $_removerAbastecimento(abastecimento) {
      if(abastecimento.excluir) {
        const index = this.secadores.findIndex((sec) => sec.scdidsecador === this.itemAbastecimento.scdidsecador);
        if (!this.secadores[index].operacao) {
          const checkNuvem = await db.abastecimentosecagem.where({id: abastecimento.abacard.id}).first();
          if(!checkNuvem.absidnuvem) await db.abastecimentosecagem.where({id: abastecimento.abacard.id}).delete();
          else await db.abastecimentosecagem.update(checkNuvem.id, {absdeletar: 'S'});
          
          this.remocaoAbastecimento = false;
          console.log('antes', this.secadores[index].scdidaberturalote)
          const nroIndex = this.secadores[index].scdidaberturalote.findIndex((nro)  => nro === abastecimento.abacard.nrolote)
          if(this.secadores[index].scdidaberturalote.length === 0) delete this.secadores[index].scdidaberturalote
          this.secadores[index].scdidaberturalote.splice(nroIndex, 1)
          console.log('dps', this.secadores[index])
          this.$_cadastroAbastecimento(this.secadores[index]);
        } else {
          errorHandler('Não pode excluir o abastecimento com uma operação já iniciada.')
          this.remocaoAbastecimento = false;
          this.abastecerLotes = true;
        }
      } else {
        const card =  await db.abastecimentosecagem.where({id: abastecimento}).first();
        const loteInfo = (await db.aberturalote.where({ablidaberturalote: card.absidaberturalote}).first());
        this.abacard = {
          id: card.id,
          inicio: card.absdatainicio,
          termino: card?.absdatatermino,
          nrolote: loteInfo.ablnrocontrole,
          status: card.absstatus
        }
        console.log('clicou remoção', abastecimento)
        this.remocaoAbastecimento = true;
        this.abastecerLotes = false;
      }
    },

    $_supostaUmidade(status, data, umidade, perdaumidade, ativo) {
      let supostaUmidade;
      if(status === 'DESLIGADO') {
        //const supostadesligado = this.$_conversaoHoraMinuto(data) - this.$_conversaoHoraMinuto(ativo)
        const supostadesligado = data - this.$_conversaoHoraMinuto(ativo)
        /* console.log(`${scd.scdidsecador}º secador`, tempoAtivo, dataPrevisao, Math.abs(supostadesligado / 60) * scd.scdperdaumidadehora)
          console.log(`${scd.scdidsecador}º secador`,Math.round((ultimaUmidade - (supostadesligado / 60) * scd.scdperdaumidadehora)/100) * 100) */
        supostaUmidade = Math.round((umidade - (supostadesligado / 60) * perdaumidade)/100) * 100;
        } else if (status === 'OPERANDO'){
          //console.log('AQUI ', ativo,this.$_conversaoHoraMinuto(data), this.$_conversaoHoraMinuto(geraData()))
          supostaUmidade = parseFloat(umidade - Math.abs(this.$_conversaoHoraMinuto(ativo) / 60) / perdaumidade).toFixed(2);
        }
      return supostaUmidade;
    },

    $_previsao(umidade, perdaumidadehora, inicio) {
      const periodoSecagem = (parseFloat(umidade) - this.empumidadecorte) * parseFloat(perdaumidadehora);
      const horas = Math.floor(periodoSecagem) < 10 ? '0' + Math.floor(periodoSecagem) : Math.floor(periodoSecagem);
      const minutos = Math.round((periodoSecagem - horas) * 60) < 10 ? 
        '0' + Math.round((periodoSecagem - horas) * 60) : Math.round((periodoSecagem - horas) * 60);
      const min = periodoSecagem * 60;
      const tempoMoment = moment(inicio).add(min, 'minutes').format("YYYY-MM-DD HH:mm");
      //return `${horas}:${minutos}`;
      return inicio ? tempoMoment : `${horas}:${minutos}`;
    },

    $_restante(previsao, data) {
      const minutoData = data ? this.$_conversaoHoraMinuto(data) : 0;
      const minutoPrevisao = this.$_conversaoHoraMinuto(previsao)
      const retorno = minutoPrevisao - minutoData < 0 ? this.$_conversaoMinutoHora((minutoPrevisao - minutoData)) : this.$_conversaoMinutoHora((minutoPrevisao - minutoData),'0')
      //console.log('RESTANTE',  previsao, retorno)
      //return this.$_conversaoMinutoHora((minutoPrevisao - minutoData),'0')
      return retorno
    },

    $_comparacaoDatas(dataMaior, dataMenor) {
      const maior = moment(geraData(dataMaior, 'MM/DD/YYYY HH:mm'));
      const menor = moment(geraData(dataMenor, 'MM/DD/YYYY HH:mm'));
      const diferencaMinutos = maior.diff(menor, 'minutes');
      //console.log('geradata', geraData(dataMaior, 'MM/DD/YYYY HH:mm'), geraData(dataMenor, 'MM/DD/YYYY HH:mm'))
      //console.log('datas', maior,menor, diferencaMinutos)
      return diferencaMinutos;
    },

    $_conversaoHoraMinuto(data) {
      let split;
      if(data) {
        if(data.length > 10) split = (geraData(data,'HH:mm')).split(':');
        else split = data.split(':');
  
        const hora = parseInt(split[0]) * 60;
        const minuto = parseInt(split[1])
        return hora + minuto
      }
    },

    $_conversaoMinutoHora(minutos, formatacao) {
      const hora = formatacao && Math.floor(minutos / 60) < 10 ? '0' + Math.floor(minutos / 60) : Math.floor(minutos / 60);
      const minuto = formatacao && (minutos % 60) < 10 ? '0' + (minutos % 60) : minutos % 60;
      return `${hora}:${minuto}`
    },

    async $_atividadeSecador(opedatainicio, perdaumidadehora,secador) {
      /* const ultimoLigado = await db.amostra.where({amodataoperacao: opedatainicio, amoidusuario: idusuario}).reverse().toArray();
      const ultimaAmostra = await db.amostra.where({amodataoperacao: opedatainicio, amoidusuario: idusuario}).reverse().first(); */
      const ultimoLigado = await db.amostra.where({amodataoperacao: opedatainicio}).reverse().toArray();
      const ultimaAmostra = await db.amostra.where({amodataoperacao: opedatainicio}).reverse().first();

      let tempoAtivo = 0;
      let tempoAtual = 0;
      let umidade;
      const dataatual = this.$_conversaoHoraMinuto(geraData())
        if (ultimaAmostra.amostatus === 'DESLIGADO') {
          for (const index in ultimoLigado) {
            const { amodataamostra, amostatus, amodatastatus} = ultimoLigado[index]
            const { amoumidade,amoumidadebaixo,amoumidadecima, amoumidademeio} = ultimoLigado[index]
            if(!umidade && !ultimaAmostra.amoumidade) {
              if (amostatus === 'LIGADO' && (amodataamostra && amodatastatus)) {
                tempoAtivo +=  this.$_comparacaoDatas(amodatastatus, amodataamostra);
                umidade = amoumidade || amoumidadebaixo || amoumidadecima || amoumidademeio || null;

              }
            } else if (ultimaAmostra.amoumidade){
              tempoAtivo = 0;
            }
          } 
          console.log(secador, this.$_conversaoMinutoHora(tempoAtivo, '0'))
          return tempoAtivo < 0 ? this.$_conversaoMinutoHora(tempoAtivo) : this.$_conversaoMinutoHora(tempoAtivo, '0');
        } else if (ultimaAmostra.amostatus === 'LIGADO') {
          
          umidade = ultimaAmostra.amoumidade || ultimaAmostra.amoumidadebaixo || ultimaAmostra.amoumidadecima;
          //const {amodataamostra} = ultimaAmostra || null;
          const dataamostra = ultimaAmostra.amodataamostra;
          const checkDia = this.$_comparacaoDatas(geraData(), dataamostra);
          //console.log('UMIDADE', umidade, ultimaAmostra, ultimoLigado)
          // VERIFICAÇÃO SE FOI APENAS ATRIBUIDO 'LIGADO', SE SIM PEGA A ULTIMA UMIDADE + TEMPO ATIVO DAQUELA AMOSTRA
          if (!umidade) {
            for (const index in ultimoLigado) {
                const { amoumidade, amoumidadebaixo, amoumidadecima, amoumidademeio } = ultimoLigado[index];
                const { amodataamostra, amodatastatus, amostatus} = ultimoLigado[index]
                //const inicioAmostra = this.$_conversaoHoraMinuto(amodataamostra)
                if (!umidade && (amoumidade || amoumidadebaixo || amoumidademeio || amoumidadecima)) {
                  umidade = amoumidade || amoumidadebaixo || amoumidadecima || amoumidademeio;
                  const atualComDia = this.$_comparacaoDatas(geraData(), dataamostra)
                  const previsaoMinutos = this.$_conversaoHoraMinuto(this.$_previsao(umidade, perdaumidadehora));
                  //const previsaoMinutos = this.$_previsao(umidade, perdaumidadehora);
                  if (ultimaAmostra.amostatus === 'LIGADO') {
                    //const terminoAmostra = this.$_conversaoHoraMinuto(amodatastatus)
                    console.log(secador,'TEMPOATIVO?????', previsaoMinutos, atualComDia,amodatastatus, amodataamostra, this.$_comparacaoDatas(amodatastatus, amodataamostra))
                    if (previsaoMinutos  < atualComDia) {
                      console.log(secador,'prev menor q atual')
                      tempoAtivo = previsaoMinutos - atualComDia;
                    } else {
                      console.log(secador,'comparacao data',ultimoLigado[index], amodatastatus, amodataamostra, this.$_comparacaoDatas(amodatastatus, amodataamostra))
                      tempoAtivo += (this.$_comparacaoDatas(amodatastatus, amodataamostra))
                      }
                  }
                }
                if (!umidade && !amodatastatus) {
                  if(geraData() < amodataamostra) {
                    console.log('com tudo consertado, ele bate aqui?')
                    tempoAtivo += Math.abs(this.$_comparacaoDatas(amodataamostra, amodataamostra))
                  }
                  else tempoAtivo += Math.abs(this.$_comparacaoDatas(geraData(), amodataamostra))
                } else if(!umidade && amodatastatus && amostatus === 'LIGADO') {
                  //const terminoAmostra = this.$_conversaoHoraMinuto(amodatastatus);
                  tempoAtivo += Math.abs(this.$_comparacaoDatas(amodatastatus,amodataamostra));
                }
              }
            //console.log(secador, this.$_conversaoMinutoHora(tempoAtivo, '0'))
            return tempoAtivo < 0 ? this.$_conversaoMinutoHora(tempoAtivo) : this.$_conversaoMinutoHora(tempoAtivo, '0');
          }else {

          const inicioAmostra = this.$_conversaoHoraMinuto(dataamostra)
          const previsaoMinutos = this.$_conversaoHoraMinuto(this.$_previsao(umidade, perdaumidadehora));
          //const previsaoMinutos = this.$_previsao(umidade, perdaumidadehora);
          tempoAtual = checkDia
          
          if (previsaoMinutos < tempoAtual) {
            tempoAtual = previsaoMinutos - tempoAtual
          } else if (inicioAmostra > (dataatual + checkDia)) tempoAtual = 0; 
          return tempoAtual < 0 ? this.$_conversaoMinutoHora(tempoAtual) : this.$_conversaoMinutoHora(tempoAtual, '0')
        }
      }
    },

    $_intervalAtualiza(){
      const interval = setInterval( async () => {
        SetupEnvioLocal()
        await this.$_load('filter'); 
        //this.$_load('filter');

      }, 20000)
      sessionStorage.setItem('intervalAtualiza', interval)
    },

    $_loop(){
      let segundos = (60 - geraData(new Date(), 'ss')) * 100;
      
      console.log('segundos', segundos)
      setTimeout(() => {
        const interval = setInterval( () => {
          console.log('ALLLLLL', this.arrAlertas)
          const operacoes = this.secadores.filter(item => {
            
            if (item.operacao !== null && item.status === 'OPERANDO') {
              return item;
            }else if(item.status === 'DESLIGADO'){
              const index = this.secadores.findIndex((sec) => sec.scdidsecador === item.scdidsecador);
              this.secadores[index].dataprevisao = this.$_previsao(item.umidade, item.perdaumidadehora, item.datainicio);
              return item;
            }
          })
          operacoes.map(async (item) => {
        
            const index = this.secadores.findIndex((sec) => sec.scdidsecador === item.scdidsecador)
            let restanteMinutos = this.$_conversaoHoraMinuto(item.datarestante)
            restanteMinutos--;

            const restanteFormatado = this.$_conversaoMinutoHora(restanteMinutos, '0');
            this.secadores.splice(index ,1, {...this.secadores[index],
            datarestante: restanteFormatado > '00:00' ? restanteFormatado : '00:00'});
            const amostra = await db.amostra.where({
              amodataoperacao: item.operacao?.opedatainicio}).reverse().first();
            const {id} = amostra;
            if (restanteFormatado === '00:00') {
              this.secadores[index].status = 'FINALIZADO'
              await db.amostra.update(id, {
                amodatastatus: geraData(),
                amodatanuvem: null
              })
            }
            //console.log(item.datarestante)
            if(item.datarestante !== '00:00') {
              const suposta = this.secadores[index].supostaumidade - ((item.perdaumidadeperc / (item.perdaumidadehora*60)))
              this.secadores[index].supostaumidade = parseFloat(suposta).toFixed(2);
            }
          })
        }, 60000)
        
        sessionStorage.setItem('interval', interval);
      }, )//segundos)
    },
    
    async $_getEmpresaCorte() {
      //const empresa = await this.$_empresa()
      this.empumidadecorte = 8 // parseFloat(empresa[0].empumidadecorte);

      // precisa fazer esses parametros no back
      this.empparametroamostra = 0.4;
      this.empprimeiraamostra = 1;
    },

    $_tv(){
      const mode = () => !this.mode
      ToggleNavigationDrawerEvent.emit(mode)
      ToggleAppBarEvent.emit(mode)
      this.checkScrollbar = document.body.scrollHeight > document.body.clientHeight
    }
  },
  created() {
    this.$_getEmpresaCorte();
    SetupEnvioLocal();
    this.$_load();
    this.$_intervalAtualiza();
    this.$_loop();
    this.$_scroll();
    this.$_abastecerQR()
    setTimeout(() => this.checkScrollbar = document.body.scrollHeight > document.body.clientHeight, 100)
  },

  destroyed() {
    const id = sessionStorage.getItem('interval')
    const idAtt = sessionStorage.getItem('intervalAtualiza')
    const idSCROLL = sessionStorage.getItem('intervalSCROLL')
    clearInterval(id);
    clearInterval(idAtt);
    clearInterval(idSCROLL);
    sessionStorage.removeItem('interval')
    sessionStorage.removeItem('intervalAtualiza')
    window.removeEventListener("scroll", (() => this.scrollPosition = null))
  },

  watch: {
    idsecador: {
      immediate:true,
      handler() {
      }
    },
    secadores: {
      immediate: true,
      handler() {
      }
    },
    scrollPosition:{
      immediate: true,
      handler() {
        let el;
        if(this.$refs.fila) {
          el = this.$refs.fila.$el.offsetTop + 30;
          this.queueAppbar = this.scrollPosition > el && !this.$refs.filaAppbar ? true : false

        }
        else {
          el = this.$refs.filaAppbar.$el.offsetTop ;
          this.queueAppbar = this.scrollPosition === 0 && !this.$refs.fila ? false : true
        }
      }
    }
  }
}
</script>

<style scoped>
  .container:first-child {
    display: unset;
    flex-wrap: wrap;
    justify-content: center;
  }

  .card-wrapper {
    display: unset;
  }

  .card-lote-wrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-inline: auto;
    max-width: 450px;
  }
  .card-lote {
    width: 100%;
  }
  .card-amostra {
    max-height: 15em;
    overflow: scroll;
  }

  .tv {
    margin-left: 45%;
    margin-top:10px;
  }
  .container-card{
    margin-top: 30px;
  }
  .fila-appbar{
    top: 50px;
    z-index: 3;
    padding-top: 15px;
    min-height: 95px;
    position: fixed;
    justify-content: center;
  }
.dialogTOP {
}
</style>